import { colorToRgba } from '@wix/panda-js-utils';
export var getSiteFontSize = function (style, referenceName) {
    // @ts-expect-error
    return style.siteTextPresets[referenceName] ? style.siteTextPresets[referenceName].size : null;
};
export var getSettingsFontSize = function (style, settingsKey) {
    return style.styleParams.fonts[settingsKey] ? "".concat(style.styleParams.fonts[settingsKey].size, "px") : null;
};
export var getFontSize = function (style, defaultSiteFont, settingsKey) {
    return getSettingsFontSize(style, settingsKey) || getSiteFontSize(style, defaultSiteFont);
};
export var getSettingsColor = function (style, settingsKey, forceOpacity) {
    var colors = style.styleParams.colors;
    var colorValue = colors[settingsKey] ? colors[settingsKey].value : null;
    if (!colorValue) {
        return null;
    }
    return colorToRgba(colorValue, forceOpacity);
};
export var getSiteColor = function (style, referenceName, forceOpacity) {
    var colorMap = getSiteColorMap(style);
    return colorToRgba(colorMap[referenceName], forceOpacity);
};
export var getColorStyle = function (style, ruleName, defaultSiteColor, settingsKey, forceOpacity) {
    var _a;
    var color = (settingsKey && getSettingsColor(style, settingsKey, forceOpacity)) ||
        getSiteColor(style, defaultSiteColor, forceOpacity);
    return color ? (_a = {}, _a[ruleName] = color, _a) : {};
};
var getSiteColorMap = function (style) {
    var map = {};
    style.siteColors.forEach(function (colorInfo) {
        map[colorInfo.reference] = colorInfo.value;
    });
    return map;
};
//# sourceMappingURL=style.js.map